module.exports = __webpack_public_path__ + "static/media/task2Planet3.b8aa4112.png";